import React from "react"
import { Button, ButtonIcon, Text } from "@gluestack-ui/themed"

interface ActionButtonProps {
  withTitles?: boolean
  isValidItem: boolean
  iconName: string
  iconFamily: any
  onPress: (event: any) => void
  title?: string
  isDisabled?: boolean
}

export const ActionButton = ({
  withTitles,
  isValidItem,
  iconName,
  iconFamily,
  onPress,
  title,
  isDisabled,
}: ActionButtonProps) => {
  return (
    <Button
      maxWidth={withTitles ? 130 : 50}
      height={50}
      px="$2"
      variant="solid"
      borderWidth={withTitles && isValidItem ? "$1" : "$0"}
      borderColor="$primary200"
      
      onPress={onPress}
      isDisabled={isDisabled}
    >
      <ButtonIcon
        as={iconFamily}
        style={{ fontWeight: "bold" }}
        name={iconName}
        color={isValidItem ? "white" : "$light400"}
        size="xl"
      />
      {withTitles && title && (
        <Text color={isValidItem ? "white" : "$light400"} ml="$1" fontWeight={isValidItem ? "bold": "normal"}>
          {title}
        </Text>
      )}
    </Button>
  )
}
